export default function Loading() {
  return <div className="flex flex-col gap-y-6">Loading</div>;
}
